/**
 * Qué entorno es este build. Lo fija vite.config.ts desde CONTEXT de Netlify.
 * En producción el modo test de Clerk y el muestrario no existen (§1.4 del plan).
 */
export const contexto = import.meta.env.VITE_CONTEXTO ?? 'local'

export const esProduccion = contexto === 'production'

export const clerkPublishableKey: string | undefined = import.meta.env
  .VITE_CLERK_PUBLISHABLE_KEY

export const identidadConfigurada = Boolean(clerkPublishableKey)

/** Ingreso con mail `+clerk_test` y código fijo: sólo fuera de producción. */
export const modoTestHabilitado = identidadConfigurada && !esProduccion
